exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".textarea_5aed511{width:400px!important;height:120px}.textarea_5aed511 .k-textarea{height:120px!important;resize:none}.tr_885e822{height:39px;line-height:39px;border-bottom:1px solid #eaecf0}.box_89f75f6 p:last-of-type{border-bottom:0 solid #eaecf0}", ""]);

// exports
exports.locals = {
	"textarea": "textarea_5aed511",
	"tr": "tr_885e822",
	"box": "box_89f75f6"
};